import { Component, Input, Output,EventEmitter, OnInit} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {Category} from "./category";
import {CategoryDataService} from "./category-data.service";
import {Query} from "./query"
declare var $:any;
import UIkit from "uikit"
import Icons from 'uikit/dist/js/uikit-icons';


UIkit.use(Icons);

@Component({

  selector: 'category-list',
  templateUrl: 'category-list-v2.html'
  //styleUrls: ['../app.css']
  })




export class CategoryListComponent implements OnInit{

  //categories: Category[];



  @Input() query: Query;  //Query passed to us
  @Output() change = new EventEmitter();//aa
  @Output() userNav = new EventEmitter();
  //@Output() change = new EventEmitter();//aa

  isMobile:Boolean =  window.screen.width<415;
  ua = navigator.userAgent.toLowerCase();
  isAndroid = this.ua.indexOf("android") > -1;

  isPad:Boolean = window.screen.width<1025;
  isPortrait: Boolean = window.innerHeight > window.innerWidth;
  service: CategoryDataService;
  editing: Category;
  listReady: Boolean = true;
  nextCategory: Category;
  parentCategory: Category;
  test: string = "TEST";






  constructor(private categoryService: CategoryDataService){

    this.service = categoryService;
    //categoryService.userNav.subscribe(item => this.handleUserNav(item));


  }
  SWIPE_ACTION = { LEFT: 'swipeleft', RIGHT: 'swiperight' };

  handleUserNav(ev:any){
    console.log('I heard it changed')
    console.log(this.query)
    if(this.query.parent!=null) this.query.parent.show=true;
    this.query.choose=true;
    this.query.set=null;
    this.query.show=false;



    this.change.emit({category:this.query.set,id:this.query.id})


  }

  /*swipe(query:Query,action = this.SWIPE_ACTION.RIGHT ) {
    console.log('SWIPE')
    this.closeQuery(query);
  }*/

  closeQuery(query:Query){

    if(query.parent!=null) query.parent.show=true;
    query.choose=true;
    query.set=null;
    this.change.emit({category:this.query.set,id:this.query.id})


  }




  handleCloseQuery(query:Query, event:KeyboardEvent){
    if (event.keyCode === 32 || event.keyCode === 13) {
      // Prevent the default action to stop scrolling when space is pressed
      event.preventDefault();
      if (query.parent != null) query.parent.show = true;
      query.choose = true;
      query.set = null;
      this.change.emit({category: this.query.set, id: this.query.id})
    }

  }





  itemClick(c:any,ev:KeyboardEvent,idx:number){
      console.log('itemClick');
      if(c && c['largeMenu']) return
      //check if its just a link
      if(c.link) {
        window.open(c.link);
        return
      }

      //this.query.set=c;

      this.query.choose=false;  //close choices
      this.setCategory(c);
      //console.log('JQ:',$('.result').get(this.query.id))

      if(this.query.id>0){
        this.query.parent.show=false;
      }

      this.service.currentQuery = this.query;

  }



  validate(c:any){
    console.log('Validating...');
    this.editing=null;
  }


  setCategory(c:Category){
    console.log('Click',c)
    //check we aren't hitting a largeMenu(class)
    if(c && c['largeMenu']) return

      $('footer').hide()
    this.query.set = c;
    this.change.emit({category:this.query.set,id:this.query.id})
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

    //
  }

  ngOnInit(){
    console.log("LIST RESULTS")
    console.log(this.query)



  }
    ngAfterViewInit(){
    console.log('View Done')
        //this.listReady=true;
        window.setTimeout(function(){
          $('.hasHTML').removeClass('hasHTML')
            if(this.query && this.query.id==0) {
                $('footer').addClass('anmated delay-2 fadeInUp')
                $('footer').show()
                //

            }

        },1000)
    }


    getHeaderTitle(){
    console.log(this.query);
    if(this.query.id>0){
      //subcats
      return this.query.parent.set.name
    }else{
      return this.query.set.name
    }

    }


}



// WEBPACK FOOTER //
// ./src/app/category/category-list.component.ts